const MFA_TEXTS = {
    login: {
        title: 'Verificação em duas etapas',
        setupIntro: 'Cadastre sua conta no aplicativo autenticador antes de continuar.',
        recurringIntro: 'Informe o código de 6 dígitos gerado no app autenticador.',
        codeRequired: 'Informe o código de 6 dígitos',
        validationError: 'Não foi possível validar o código de verificação',
        expiredSession: 'Sessão de verificação expirada. Faça login novamente.',
        manualKeyLabel: 'Chave manual',
        verificationCodeLabel: 'Código de verificação*',
        verificationCodePlaceholder: 'Código de 6 dígitos',
        validatingAction: 'Validando',
        setupAction: 'Ativar verificação em duas etapas',
        validateAction: 'Validar código',
        backAction: 'Voltar para o login',
    },
    profile: {
        title: 'Verificação em duas etapas',
        cardDescription: 'Cadastre um aplicativo autenticador para proteger seu acesso.',
        configureAction: 'Ativar verificação em duas etapas',
    },
    selfService: {
        title: 'Verificação em duas etapas',
        activeTitle: 'Você já ativou a verificação em duas etapas',
        setupDescription:
            'Cadastre sua conta no aplicativo autenticador antes de continuar.',
        activeDescription:
            'Este acesso já está protegido com a verificação em duas etapas. Não é necessário realizar uma nova configuração.',
        activeFeedback: 'Verificação em duas etapas já ativada.',
        successFeedback: 'Verificação em duas etapas ativada com sucesso.',
        loadError: 'Erro ao carregar a verificação em duas etapas.',
        startError: 'Erro ao iniciar a verificação em duas etapas.',
        codeRequired: 'Informe o código de 6 dígitos.',
        invalidCode: 'Código de verificação inválido.',
        lockedByPolicy:
            'A verificação em duas etapas é obrigatória pela empresa. A opção não pode ser desativada pelo usuário.',
        loadingAction: 'Carregando...',
        configureAction: 'Ativar verificação em duas etapas',
        closeAction: 'Entendi',
        manualKeyLabel: 'Chave manual',
        verificationCodeLabel: 'Código de verificação*',
        verificationCodePlaceholder: 'Código de 6 dígitos',
        validatingAction: 'Validando...',
        confirmAction: 'Ativar verificação em duas etapas',
        cancelAction: 'Cancelar',
        activeLabel: 'Ativo',
        inactiveLabel: 'Inativo',
    },
};

export default MFA_TEXTS;
